<template>
  <section class="mb-4">
    <!-- Título -->
    <header class="flex items-center gap-2 mb-2">
      <b-icon pack="fas" :icon="icon" size="is-small" class="text-blue-light" />
      <h3 class="m-0 text-base font-bold text-blue-darker">{{ title }}</h3>
    </header>
    <!-- Contenido -->
    <div class="p-4 bg-white border border-blue-lighter rounded-lg comment-lists entity-description__card">
      <div v-html="content" class="text-sm leading-relaxed text-gray-700"></div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'entity-description',

    props: {
      title: {type: String, required: true},
      content: {type: String, required: true},
      icon: {type: String, default: 'align-left'},
    }

  };
</script>

<style>
  /* El tailwind del proyecto (v2 sin JIT) no tiene min-h intermedios */
  .entity-description__card {
    min-height: 5.5rem;
  }

  .comment-lists {
    overflow-wrap: break-word;
  }

  .comment-lists ul {
    list-style: disc !important;
    padding-left: 1.5em;
  }

  .comment-lists ol {
    padding-left: 1.5em;
  }
</style>
